/* eslint-disable no-use-before-define */
import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Paper } from '@material-ui/core';
import { listEntryType } from '../../services/AdmEntryTypeService';
import color from '../../assets/css/colors';
import fontFamily from '../../assets/css/fonts';

const useStyles = makeStyles(() => ({
  autocompleteWrapper: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '7px 50px 8px 15px !important',
    },
    '& .MuiAutocomplete-option': {
      backgroundColor: 'red',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 15px)',
      '& svg': {
        width: '22px !important',
        height: '22px !important',
      },
    },
  },
  paper: {
    fontFamily: fontFamily.label,
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: color.light.main,
  },
}));

export const SelectEntryType = (props) => {
  const classes = useStyles();

  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (options.length === 0) {
      getOptions();
    }
    // eslint-disable-next-line
  }, []);

  const getOptions = async () => {
    const { entryTypesList } = await listEntryType({
      entryType: '',
      correspondent: '',
      accountNo: '',
      screenType: '',
      multiple: true,
    });

    const list = entryTypesList.filter((s) => s.entryType);
    const nonTrade = {
      entryType: 'NON TRD',
      entryTypeDescription: 'Non Trade Entry',
    };

    list.push(nonTrade);
    setOptions(list);
  };

  const setPropsValue = (value) => {
    props.onChange({
      currentTarget: {
        name: props.name,
        value: value,
      },
      target: {
        name: props.name,
        value: value,
      },
    });
  };

  return (
    <div className={classes.root}>
      <Autocomplete
        className={classes.autocompleteWrapper}
        multiple
        disabled={props.disabled}
        options={options}
        getOptionLabel={(option) => {
          return option.entryType
            ? option?.entryType + ' - ' + option?.entryTypeDescription
            : '';
        }}
        getOptionSelected={(option, value) => {
          return option.entryType === value.entryType;
        }}
        onChange={(e, value) => {
          setPropsValue(value);
        }}
        onKeyDown={props.onKeyDown}
        value={props.value}
        PaperComponent={({ children }) => (
          <Paper className={classes.paper}>{children}</Paper>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            name={props.name}
            required={props.required}
            disabled={props.disabled}
            label={props.label}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </div>
  );
};
